<template>
  <div class="beratung">
    <h1>Beratung</h1>
    <ul>
      <li><router-link to="/stillberatung/">Stillvorbereitung</router-link></li>
      <li><router-link to="/schlafberatung/">Schlafberatung</router-link></li>
      <li><router-link to="/beikostberatung/">Beikostberatung</router-link></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Beratung'
}
</script>

<style scoped>
.beratung {
}
</style>